import { addDoc, collection, deleteDoc, doc, onSnapshot, query, updateDoc } from "firebase/firestore";
import { firestore } from "../../../configs/FirebaseConfig";
import useSWRSubscription from "swr/subscription";
import { FIRESTORE_CHATBOT_DATA_SOURCES_TABLE, FIRESTORE_REGIONS_TABLE } from "../../../constants/FirestoreConstant";
import { COMPANY_COUNTRY_CODE } from "../../../constants/CompanyConstants";
import dayjs from "dayjs";

export function useContextItems() {
  const { data, error } = useSWRSubscription("contextItems", (key, { next }) => {
    const q = query(
      collection(
        firestore,
        `${FIRESTORE_REGIONS_TABLE}/${COMPANY_COUNTRY_CODE}/${FIRESTORE_CHATBOT_DATA_SOURCES_TABLE}`,
      ),
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        try {
          const items = snapshot.docs
            .map((doc) => ({
              id: doc.id,
              ...doc.data(),
            }))
            .sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0));

          next(null, items);
        } catch (err) {
          next(err, null);
        }
      },
      (error) => {
        next(error, null);
      },
    );

    return () => unsubscribe();
  });

  const createContextItem = async (payload) => {
    const now = dayjs().unix();
    const docRef = await addDoc(
      collection(
        firestore,
        `${FIRESTORE_REGIONS_TABLE}/${COMPANY_COUNTRY_CODE}/${FIRESTORE_CHATBOT_DATA_SOURCES_TABLE}`,
      ),
      {
        ...payload,
        usage: payload.usage || 0,
        createdAt: now,
        updatedAt: now,
      },
    );
    return docRef.id;
  };

  const updateContextItem = async (id, patch) => {
    await updateDoc(
      doc(firestore, `${FIRESTORE_REGIONS_TABLE}/${COMPANY_COUNTRY_CODE}/${FIRESTORE_CHATBOT_DATA_SOURCES_TABLE}`, id),
      {
        ...patch,
        updatedAt: dayjs().unix(),
      },
    );
  };

  const deleteContextItem = async (id) => {
    await deleteDoc(
      doc(firestore, `${FIRESTORE_REGIONS_TABLE}/${COMPANY_COUNTRY_CODE}/${FIRESTORE_CHATBOT_DATA_SOURCES_TABLE}`, id),
    );
  };

  return {
    data,
    error,
    loading: !data && !error,
    createContextItem,
    updateContextItem,
    deleteContextItem,
  };
}
